module.exports = __webpack_public_path__ + "img/arrow.e34fad12.svg";